module.exports = __webpack_public_path__ + "img/ic-unionbank.562f97ee.png";